<template>
  <div>
    <v-card max-width="1000" class="mx-auto" elevation="0">
      <v-container grid-list-lg>
        <v-subheader> All products </v-subheader>
        <v-layout wrap>
          <v-flex
            v-for="product in products"
            :key="`product-` + product.id"
            class="hidden-sm-and-down"
            xs2
          >
            <product-item
              :product="product"
              class="red--text align-self-stretch"
              max-height="200px"
              max-width="200px"
            />
          </v-flex>
          <v-flex
            v-for="product in products"
            :key="`product-` + product.id"
            class="hidden-sm-and-up"
            xs6
          >
            <product-item
              :product="product"
              class="red--text align-self-stretch"
              max-height="200px"
              max-width="200px"
            />
          </v-flex>
        </v-layout>
      </v-container>

      <template>
        <div class="text-center">
          <v-pagination
            v-model="page"
            @input="go"
            :length="lengthPage"
            :total-visible="5"
          ></v-pagination>
        </div>
      </template>
    </v-card>
  </div>
</template>
<script>
export default {
  components: {
    ProductItem: () =>
      import(/* webpackChunkName: "product-item" */ "@/components/ProductItem.vue"),
  },
  data: () => ({
    products: [],
    page: 0,
    lengthPage: 0,
  }),
  created() {
    this.go();
  },
  methods: {
    go() {
      let url = "/ecommerce-products?page=" + this.page;
      this.axios
        .get(url)
        .then((response) => {
          let { data } = response.data;
          let { meta } = response.data;
          this.products = data;
          // jumlah halaman di dapat dari meta endpoint products
          this.lengthPage = meta.last_page;
          this.page = meta.current_page;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
  },
};
</script>
